<script>
export default {
    name: 'IconArrowRight'
}
</script>
<template>
    <svg
        class="base-icon icon-arrow-right"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32.03 8L56 31.9l-.1.099.1.1L32.03 56l-4.23-4.218 16.848-16.8H8v-5.964l36.648-.001-16.849-16.8L32.03 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
